import { ALL_ITEMS_QUERY } from "../../../graphql/Items/Items.graphql";
import { ALL_ITEM_CATEGORIES_QUERY } from "../../../graphql/ItemCategories/ItemCategories.graphql";
import { ALL_INVENTORY_STORAGE_DIMS_QUERY } from "../../../graphql/InventoryStorageDims/InventoryStorageDims.graphql";
import { ALL_ITEM_TRANSACTIONS_QUERY } from "../../../graphql/Items/ItemTransactions.graphql";
import { ALL_INVENTORY_ON_HAND_QUERY } from "../../../graphql/Items/InventoryOnHand.graphql";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

export default {
  name: "Inventory Management",
  label: "Inventory",
  icon: "warehouse",
  permissions: ["INV", "ADMIN", "FIN"],
  active: location => location.pathname.includes("inventory"),
  links: [
    {
      name: "Setup",
      links: [
        {
          name: "Item Categories",
          to: "/inventory/item-categories",
          query: ALL_ITEM_CATEGORIES_QUERY,
          filters: "ITEM_FILTERS"
        },
        {
          name: "Storage Dimensions",
          to: "/inventory/storage-dims",
          query: ALL_INVENTORY_STORAGE_DIMS_QUERY,
          filters: "INVENTORY_STORAGE_DIM_FILTERS"
        }
      ]
    },
    {
      name: "Inventory Processing",
      links: [
        {
          name: "Item Master",
          to: "/inventory/items",
          query: ALL_ITEMS_QUERY,
          filters: "ITEM_FILTERS"
        },

        {
          name: "Item Transactions",
          to: "/inventory/item-transactions",
          query: ALL_ITEM_TRANSACTIONS_QUERY,
          filters: "ITEM_TRANSACTION_FILTERS"
        },
        {
          name: "Item On-Hand Inquiry",
          to: "/inventory/inventory-on-hand",
          query: ALL_INVENTORY_ON_HAND_QUERY,
          filters: "INVENTORY_ON_HAND_FILTERS"
        }
      ]
    },
    {
      name: "Reports",
      links: [
        {
          name: "Item Usage",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=ItemUsage`
        },
        {
          name: "Inventory On-Hand",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=InventoryOnHand`
        },
        {
          name: "Inventory On-hand Below Minimum",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=ItemsOnHandBelowMin`
        },
        {
          name: "Inventory Transactions",
          href: `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=InventoryTransactions`
        }
      ]
    }
  ]
};
